/**
 * Check whether all required fields are valid. If so, returns true
 * @param {object} formData - the object containing formData
 * @param {array} newImages - array containing new image objects
 */
export const hasValidPrice = (formData) => {
  const priceFields = [
    formData?.hourly_rent,
    formData?.daily_rent,
    formData?.monthly_rent,
    formData?.workspace_rent,
  ];
  // Konvertera till tal och filtrera bort tomma/NaN
  const filledPrices = priceFields
    .map((price) => parseFloat(price))
    .filter((price) => !isNaN(price));
  // Om inget fält är ifyllt, returnera false, behöver minst ett pris
  if (filledPrices.length === 0) {
    return false;
  }
  // Kontrollera att alla ifyllda fält är > 0
  return filledPrices.every((price) => price > 0);
};

export const requiredFieldsCheck = (formData, newImages) => {
  const imageCount = newImages?.length + (formData?.images?.length || 0);
  const images = imageCount >= 4 && imageCount <= 12;
  const rent = hasValidPrice(formData);

  return (
    formData?.owner_name &&
    formData?.address &&
    formData?.city &&
    formData?.municipality &&
    formData?.zip_code &&
    formData?.type_of_room &&
    formData?.area &&
    formData?.description &&
    images &&
    rent
  );
};

/**
 *  Authenticate all required fields. And toggle their error messages. returns boolean
 * @param {object} formData - the object containing formData
 * @param {array} newImages - array containing new image objects
 * @param setInvalidFields - useState set function that expects a array of field names
 */
export const authenticateForm = (formData, newImages, setInvalidFields) => {
  if (requiredFieldsCheck(formData, newImages)) {
    return true; // Authentication passed
  } else {
    // const requiredFields = [
    //   "owner_name",
    //   "address",
    //   "city",
    //   "municipality",
    //   "zip_code",
    //   "type_of_room",
    //   "area",
    //   "description",
    // ];

    const invalidFields = [];

    // Kollar fälten för att kolla om något finns i dem
    // om inte valid så pushas fältet in i invalidFields[]
    if (!formData?.owner_name) invalidFields.push("owner_name");
    if (!formData?.address) invalidFields.push("address");
    if (!formData?.city) invalidFields.push("city");
    if (!formData?.municipality || formData?.municipality === "Välj kommun")
      invalidFields.push("municipality");
    if (!formData?.zip_code || !/^\d{5}$/.test(formData.zip_code))
      invalidFields.push("zip_code");
    if (!formData?.type_of_room || formData?.type_of_room === "Typ av lokal")
      invalidFields.push("type_of_room");
    if (!formData?.area || Number(formData.area) <= 0) invalidFields.push("area");
    if (!formData?.description) invalidFields.push("description");

    // Kollar bilder för att se om det finns några
    // Om det inte finns så pushas fältet in invalidFields[]
    const imageCount =
      (newImages?.length || 0) + (formData?.images?.length || 0);
    if (imageCount < 4 || imageCount > 12) invalidFields.push("images");

    // Kollar om ingen av fälten finns
    // Om det inte finns så pushas fältet in i invalidFields
    // if (!formData?.hourly_rent && !formData?.daily_rent && !formData?.workspace_rent && !formData?.monthly_rent) {
    //   invalidFields.push("rent");
    // }
    if (!hasValidPrice(formData)) {
      invalidFields.push("rent");
    }

    setInvalidFields(invalidFields);

    return invalidFields.length === 0;
  }
};
